
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IClaim} from "@/modules/barriers/interfaces/claim.interface";
  import {httpResource} from "@/resources/http.resource";
  import {IBook} from "@/interfaces/book.interface";
  import {IApp} from "@/interfaces/app.interface";
  import {bus} from "@/plugins/bus";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
  import PhoneInput from "@/components/PhoneInput.vue";

  @Component({
    components: {
      AppDialog,
      PhoneInput,
    },
  })
  export default class ClaimsPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'barriers', dialogName: 'claimsPopup' };
    popupReady = false;
    dataReady = false;
    formModel: IClaim.IForm = {
      carNumber: '',
      claimTypeId: 5,
      phone: '',
      comment: '',
    };
    formRules = {
      carNumber: [{
        validator: (rule, value, callback) => {
          let valid = value.length >= 7 && value.length <= 9;
          return valid ? callback() : callback(new Error('Номер должен состоять из 7-9 знаков'))
        },
        required: true,
        message: 'Номер должен состоять из 7-9 знаков',
        trigger: 'blur'
      }],
      phone: [{ required: true, message: ' ', trigger: 'blur' }],
      comment: [{ required: true, message: ' ', trigger: 'blur' }],
    };
    localModel = {
      acceptRules: false,
    };
    firstClaim = true;
    previousClaim = {
      claimDate: '',
      sum: 0,
      parkName: '',
    };
    dateFormats = IApp.DateFormats;
    pickerOptions = IApp.DatePickerOptions.Simple;

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get claimTypes(): IBook.CatalogData[] { return this.$store.state.book.books[IBook.BookName.claimTypes]; }

    async created() {
      this.popupReady = false;

      if (this.$store.state.auth.isUser) {
        await this.$store.dispatch('profile/init');
        this.formModel.phone = this.$store.state.profile.profileData.phone;
        this.formModel.carNumber = this.payloadPopup.carNumber;
      }

      await this.getInfo();

      this.popupReady = true;
    }

    async mounted() {
      KeyboardMobileHidden();
    }

    async getInfo() {
      let asyncAction = async () => {
        let params: any = {
          command: IClaim.Command.Get,
          carNumber: this.payloadPopup.carNumber,
        };
        const { data: { result: response } } = await httpResource.httpAction({ action: IClaim.Action, params });
        if (response && response[0]) {
          this.firstClaim = false;
          this.previousClaim = {
            claimDate: response[0].dateLast,
            sum: response[0].tSumDolg,
            parkName: response[0].parkName,
          };
        }
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async openBarrier() {
      this.$refs.claimForm.validate(async (valid) => {
        if (!valid || !this.localModel.acceptRules) return false;

        let asyncAction = async () => {
          let params: any = {
            command: IClaim.Command.Set,
            carNumber: this.payloadPopup.carNumber,
            tSum: this.payloadPopup.tSum,
            ...this.formModel,
          };
          await httpResource.httpAction({action: IClaim.Action, params});
        };
        const success = await this.$store.dispatch('defaultResourceAction', {asyncAction});
        if (success) {
          this.$notify({
            title: 'Успешно',
            message: 'Шлагбаум должен открыться',
            type: 'success'
          });
          await this.onClose();
        }
        else {
          this.$notify.error({
            title: 'Ошибка',
            message: 'Произошла ошибка, попробуйте снова',
          });
        }
      });
    }

    async goToAuth() {
      await this.$store.dispatch('openPage', {routeName: IApp.ROUTE_NAME.PAGE_AUTHORIZATION});
    }

    async openPayment() {
      this.$refs.claimForm.validate(async (valid) => {
        if (!valid) return false;
        await this.onClose();

        await this.$store.dispatch('dialog/openDialog', {
          blockName: 'payment',
          dialogName: 'payByCardPopup',
          payload: {
            carNumber: this.payloadPopup.carNumber,
            enterByQR: false,
            tSum: this.previousClaim.sum,
            closeBalance: true,
            phone: this.payloadPopup.phone,
            email: this.payloadPopup.email,
            closeAction: async () => {
              bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
            },
          }
        });
      });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }

  }
